import React from 'react';
import { useTranslation } from 'react-i18next';

const OpportunitySection = () => {
  const { t } = useTranslation('home');

  const opportunities = [
    {
      icon: 'ri-map-pin-line',
      title: t('opportunity.item1.title'),
      shortDesc: t('opportunity.item1.desc'),
      fullDesc: t('opportunity.item1.desc'),
    },
    {
      icon: 'ri-truck-line',
      title: t('opportunity.item2.title'),
      shortDesc: t('opportunity.item2.desc'),
      fullDesc: t('opportunity.item2.desc'),
    },
    {
      icon: 'ri-price-tag-3-line',
      title: t('opportunity.item3.title'),
      shortDesc: t('opportunity.item3.desc'),
      fullDesc: t('opportunity.item3.desc'),
    },
    {
      icon: 'ri-shopping-bag-3-line',
      title: t('opportunity.item4.title'),
      shortDesc: t('opportunity.item4.desc'),
      fullDesc: t('opportunity.item4.desc'),
    },
  ];

  return (
    <section className="py-10 sm:py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-6 sm:mb-12 md:mb-16">
          <h2 className="text-xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-2 sm:mb-4">
            {t('opportunity.title')}
          </h2>
          <p className="text-xs sm:text-base md:text-xl text-gray-600 max-w-3xl mx-auto">
            {t('opportunity.description')}
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-6 md:gap-8">
          {opportunities.map((item, index) => (
            <div
              key={index}
              className="group bg-gradient-to-br from-gray-800 to-gray-900 rounded-xl sm:rounded-2xl p-4 sm:p-6 md:p-8 border border-amber-500/20 hover:border-amber-500/50 transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-10 h-10 sm:w-14 sm:h-14 md:w-16 md:h-16 flex items-center justify-center bg-gradient-to-br from-amber-500 to-yellow-600 rounded-lg sm:rounded-xl mb-3 sm:mb-5 md:mb-6 group-hover:scale-110 transition-transform">
                <i className={`${item.icon} text-lg sm:text-2xl md:text-3xl text-black`}></i>
              </div>
              <h3 className="text-sm sm:text-lg md:text-xl font-bold text-white mb-1.5 sm:mb-3">
                {item.title}
              </h3>
              <p className="text-gray-400 text-xs sm:text-sm leading-relaxed">
                <span className="block sm:hidden">{item.shortDesc}</span>
                <span className="hidden sm:block">{item.fullDesc}</span>
              </p>
            </div>
          ))}
        </div>

        {/* Additional Info */}
        <div className="mt-6 sm:mt-12 md:mt-16 bg-gradient-to-r from-amber-400 to-yellow-500 rounded-xl sm:rounded-2xl p-4 sm:p-6 md:p-8 shadow-xl">
          <div className="flex flex-col sm:flex-row items-start gap-3 sm:gap-0">
            <div className="w-10 h-10 sm:w-14 sm:h-14 flex items-center justify-center flex-shrink-0 bg-black/20 rounded-lg sm:rounded-xl">
              <i className="ri-award-line text-2xl sm:text-3xl text-white"></i>
            </div>
            <div className="sm:ml-6">
              <h3 className="text-base sm:text-xl md:text-2xl font-bold text-black mb-1.5 sm:mb-3">
                {t('opportunity.latvia.title')}
              </h3>
              {/* Mobile: short version */}
              <p
                className="block sm:hidden text-gray-900 leading-relaxed text-xs"
                dangerouslySetInnerHTML={{ __html: t('opportunity.latvia.desc.short') }}
              />
              {/* Desktop: full version */}
              <p
                className="hidden sm:block text-gray-900 leading-relaxed text-sm sm:text-base"
                dangerouslySetInnerHTML={{ __html: t('opportunity.latvia.desc.full') }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OpportunitySection;